import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const getNavigationConfig = createAsyncThunk('getNavigationConfig', async () => {
    const response = await axios.get(`/top-menu`);

    return response.data;
});
